import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["data"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useState, useMemo } from "react";
import List from "@/components/List";
import ListRow from "@/components/Row/ListRow/index";
import ContentHeader from "@/components/ContentHeader";
import DateTab from "@/components/DateTab";
import { useChannelLiveScheduleQuery } from "@/hooks";
import NoContentMessage from "@/components/NoContentMessage";
import dayjs from "@/lib/day";
import styles from "@/styles/Channel.module.scss";
import { LIST_PAGE_LIMIT } from "@/lib/constants";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ChannelLiveSchedule(_ref) {
  var id = _ref.id;

  var _useState = useState(dayjs().format("YYYY-MM-DD")),
      selectedDay = _useState[0],
      setDay = _useState[1];

  var _useChannelLiveSchedu = useChannelLiveScheduleQuery({
    variables: {
      id: id,
      day: selectedDay,
      offset: 0,
      limit: LIST_PAGE_LIMIT
    }
  }),
      data = _useChannelLiveSchedu.data,
      result = _objectWithoutProperties(_useChannelLiveSchedu, _excluded);

  var items = data === null || data === void 0 ? void 0 : data.channelLiveSchedule;
  var headerText = useMemo(function () {
    return "".concat(dayjs(selectedDay).format("M/D（dd）"), "\u306E\u756A\u7D44");
  }, [selectedDay]);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.liveSchedule,
    children: [/*#__PURE__*/_jsx(ContentHeader, {
      text: headerText
    }), /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(DateTab, {
        selectedDay: selectedDay,
        onClick: setDay
      })
    }), /*#__PURE__*/_jsx("div", {
      className: styles.content,
      children: /*#__PURE__*/_jsx(List, _objectSpread(_objectSpread({}, result), {}, {
        itemComponent: ListRow,
        items: items,
        limit: LIST_PAGE_LIMIT,
        noContent: /*#__PURE__*/_jsx(NoContentMessage, {
          message: "\u3053\u306E\u65E5\u306E\u30E9\u30A4\u30D6\u306F\u3042\u308A\u307E\u305B\u3093\u3002"
        })
      }), "channel-".concat(id, "-live-").concat(selectedDay))
    })]
  });
}